export default __webpack_public_path__ + "static/media/logo_colorido.4a89f5c3.png";